import {FormulaCalculator} from "./FormulaCalculator";

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.wpforms-field-calculation').forEach((element) => {
        let fieldId=element.getAttribute('data-field-id');

        let data:string=element.querySelector('input').getAttribute('data-calculation');
        try{
            data=atob(data);
            data=JSON.parse(data);

            new FormulaCalculator(element as any,data).Initialize();
        }catch (e){
            alert(e)
        }
    });
});